import {
  AmplitudeContext,
  AmplitudeEventHelpers,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import {
  selectInstantOfferVideoId,
  selectInstantOfferVideoType,
} from '../../../../store/selectors/videos'
import {
  selectCustomerType,
  selectCustomerFirstName,
} from '../../../../store/selectors/customerProfile'
import classnames from 'classnames'
import { Player } from '../../Player'
import { useContext, useState } from 'react'
import { Page, Button, Text } from '../../..'
import { useIntl, defineMessages } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { SlideOnMount, FadeOnMount } from '../../Animations'
import ErrorLogoWithMessage from '../../Error/LogoWithMessage'
import { selectHasCMA } from '../../../../store/selectors/home/cma'
import { trackInstantOfferRequested } from '../../../../actions/home'
import HomeFacts from '../../../homeowners/Valuation/HomeFacts/HomeFacts'
import { setValuationHomeFactsProgress } from '../../../../actions/valuation'
import { InstantOfferConfirmationPanel } from './InstantOfferConfirmationPanel'
import { selectHomeFactsProgress } from '../../../../store/selectors/valuation'

import styles from './InstantOffer.module.scss'
import panelStyles from '../../Panel/Panel.module.scss'

export const MSG = defineMessages({
  head: {
    id: 'Homeowner.instantOffer.header',
    defaultMessage: 'What is an instant offer?',
  },
  body: {
    id: 'Homeowner.instantOffer.body',
    defaultMessage:
      'An instant offer could be an alternative way to sell your home or gauge its current market value. Work with {name} to better understand instant offers!',
  },
  info: {
    id: 'Homeowner.instantOffer.moreInfo',
    defaultMessage: 'Get more info',
  },
  error: {
    id: 'Homeowner.instantOffer.player.error',
    defaultMessage: 'Unable to recognize player settings. Cannot render video.',
  },
})

export const InstantOffer = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const hasCma = useSelector(selectHasCMA)
  const [success, setSuccess] = useState(false)
  const { ampli } = useContext(AmplitudeContext)
  const customerType = useSelector(selectCustomerType)
  const progress = useSelector(selectHomeFactsProgress)
  const videoId = useSelector(selectInstantOfferVideoId)
  const videoType = useSelector(selectInstantOfferVideoType)
  const customerFirstName = useSelector(selectCustomerFirstName)

  const handleClick = () => {
    dispatch(trackInstantOfferRequested())
    ampli?.clientRequestedInfo({
      request_type: AmplitudeEventConstants.INSTANT_OFFER,
      customer_type:
        AmplitudeEventHelpers.getAmplitudeCustomerType(customerType),
    })

    hasCma ? setSuccess(true) : dispatch(setValuationHomeFactsProgress(20))
  }

  return (
    <Page>
      <Page.Body className={styles.body}>
        {!success && !progress && (
          <>
            <SlideOnMount
              className={classnames(panelStyles.headWrap, styles.head)}
            >
              <Text
                size='xl'
                align='center'
                variant='neutralCool'
                variantCount='900'
              >
                {intl.formatMessage(MSG.head)}
              </Text>
              <Text variant='neutralCool' variantCount='700' size='s'>
                {intl.formatMessage(MSG.body, {
                  name: customerFirstName,
                })}
              </Text>
            </SlideOnMount>
            <SlideOnMount className={panelStyles.contentWrap}>
              {videoType && videoId && (
                <Player
                  videoType={videoType}
                  videoId={videoId}
                  className={styles.videoPlayer}
                />
              )}
              {!videoType && !videoId && (
                <ErrorLogoWithMessage>
                  {intl.formatMessage(MSG.error)}
                </ErrorLogoWithMessage>
              )}
            </SlideOnMount>
            <FadeOnMount className={panelStyles.submitWrap}>
              <Button primary fullWidth onClick={handleClick}>
                {intl.formatMessage(MSG.info)}
              </Button>
            </FadeOnMount>
          </>
        )}
        {!success && progress && progress !== 100 && <HomeFacts />}
        {(success || progress === 100) && <InstantOfferConfirmationPanel />}
      </Page.Body>
    </Page>
  )
}
